const priceConstants = {
	GET_PRICE: "GET_PRICE",
	CLEAR_PRICING: "CLEAR_PRICING",
	REMOVE_PRICE_PER_BUILDING: "REMOVE_PRICE_PER_BUILDING",
	REMOVE_BUILDING_TOTAL_PRICE: "REMOVE_BUILDING_TOTAL_PRICE",
};

export default priceConstants;
